export default __webpack_public_path__ + "static/media/logo-full.e73d7c2d.png";